// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q3Br","content":"styles_content__2D2lx","tableWrap":"styles_tableWrap__2Webi"};